import { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { SpotifyAuth } from 'react-spotify-auth';
import Cookies from 'js-cookie';
import api from '../requests/api';
import Settings from './Settings';
import { Artist1Context, Artist2Context } from '../context';
import { clientId } from '../constants';

function App() {
  const [loadingFirst, setLoadingFirst] = useState(false);
  const [loadingSecond, setLoadingSecond] = useState(false);
  const [firstArtist, setFirstArtist] = useContext(Artist1Context);
  const [secondArtist, setSecondArtist] = useContext(Artist2Context);
  const [token, setToken] = useState(Cookies.get('spotifyAuthToken'));

  async function getRandom2Artists(recalling) {
    if (Cookies.get('spotifyAuthToken')) {
      if ((loadingFirst || loadingSecond) && !recalling) return;
      setLoadingFirst(true);
      setLoadingSecond(true);
      const res1 = await api.sendRandomArtistRequest(setLoadingFirst);
      const res2 = await api.sendRandomArtistRequest(setLoadingSecond);
      if (res1.name === res2.name) {
        getRandom2Artists(true);
        return;
      }
      setFirstArtist(res1);
      setSecondArtist(res2);
    }
  }
  return (
    <div className="w-screen h-screen flex justify-center items-center bg-gradient-to-b from-black  to-zinc-800">
      <Settings />
      <div className="flex flex-col justify-center items-center w-full">
        {!token && (
        // Display the login page
        <SpotifyAuth
          redirectUri="https://elastic-northcutt-a520c2.netlify.app"
          clientID={clientId}
          onAccessToken={(t) => setToken(t)}
          scopes={['user-top-read']}
          btnClassName="border border-white font-light bg-zinc-600 hover:bg-zinc-500 text-white font-bold py-2 px-4 rounded-full mb-4 w-64 text-center"
          noLogo
          title="Login before playing"
        />
        )}
        <button
          className="border border-white font-light bg-zinc-600 hover:bg-zinc-500 text-white font-bold py-2 px-4 rounded-full mb-4 w-60 text-center"
          onClick={() => getRandom2Artists(false)}
          type="button"
        >
          Generate 2 random artists!
        </button>
        {firstArtist && secondArtist && !loadingFirst && !loadingSecond ? (
          <div className="h-36 flex flex-col items-center justify-center">
            <div className="flex flex-row items-center justify-center">
              <div className="flex flex-col items-center">
                <h1 className="mb-2 text-white w-40 text-center">
                  {firstArtist.name}
                </h1>
                {firstArtist.images?.length > 0 && (
                  <img
                    src={firstArtist.images[0].url}
                    alt="artist"
                    className="drop-shadow w-20 h-20 rounded-full border-2 border-white"
                  />
                )}
              </div>
              <div className="w-60 border-t-2 border-white border-dashed" />
              <div className="flex flex-col items-center">
                <h1 className="mb-2 text-white w-40 text-center">
                  {secondArtist.name}
                </h1>
                {secondArtist.images?.length > 0 && (
                  <img
                    src={secondArtist.images[0].url}
                    alt="artist"
                    className="drop-shadow w-20 h-20 rounded-full border-2 border-white"
                  />
                )}
              </div>
            </div>
            <Link
              to="/game"
              className="border border-white font-light bg-zinc-600
              hover:bg-zinc-500 text-white font-bold py-2 px-4 rounded-full mb-4 w-60 text-center"
            >
              Play game!
            </Link>
          </div>
        ) : (
          <div className="h-36" />
        )}
      </div>
    </div>
  );
}

export default App;
